export const EDIT_CHIEF_COMPLAINT_DETAILS = {
  CHIEF_COMPLAINT: "chiefComplaint",
};

export const lABEL_STYLE = {
  fontSize: "16px",
  fontWeight: 500,
  color: "#393939",
  marginBottom: "10px",
};
